var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1464 3.49844L7.3049 6.99844L11.1464 10.4984L10.3781 11.8984L5.00002 6.99844L10.3781 2.09844L11.1464 3.49844Z",
    fill: "#3A57E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLeftArrow);
export default __webpack_public_path__ + "static/media/slider-left-arrow.2d5483a8f138f82c2dadb3c0187c397b.svg";
export { ForwardRef as ReactComponent };